import {Constructor} from "../../../../global/constructor";
import {RelationType} from "~/models/relationType";
import ConditionalRuleSetFactory from "~/models/conditionalRules/conditionalRuleSetFactory";
import {IEmbeddedModelHash} from "~/interfaces/modelInterfaces";
import {ConditionalFieldDefinition} from "~/models/conditionalRules/conditionalFieldDefinition";
import IConditionalRuleContainer from "~/models/conditionalRules/conditionalRuleContainer";
import TrackedModel from "~/models/tracked/trackedModel";
import {Hash} from "~/interfaces/hashInterfaces";

interface IBuilderModelConditionalRuleContainer extends IConditionalRuleContainer {
  createEmbeddedObject: Hash<(parent, json) => TrackedModel>;
  except: string[];
}

export class ConditionalRuleEmbeddedModelsHelper {
  static addEmbeddedModels(
    embeddedModels: IEmbeddedModelHash,
    conditionalFields: Array<ConditionalFieldDefinition>,
    ruleSetType: Constructor,
    defaultValueType: Constructor = Object,
  ) {
    for (const definition of conditionalFields) {
      embeddedModels[`${definition.fieldName}_conditional_rule_sets`] = {type: ruleSetType, relationType: RelationType.dictionary};
      if (definition.defaultConditionalValue instanceof Function) {
        embeddedModels[definition.fieldName] = {type: defaultValueType, relationType: RelationType.singleObject};
      }
    }
  }

  // Has the side-effect of mutating container's "except" array.
  static defineEmbeddedModelsCreation(
    container: IBuilderModelConditionalRuleContainer,
    conditionalFields,
  ) {
    for (const definition of conditionalFields) {
      const conditionalFieldName = `${definition.fieldName}_conditional_rule_sets`;
      container.except.push(conditionalFieldName);
      container[conditionalFieldName] = {};
      container.createEmbeddedObject[conditionalFieldName] = (parent, json) => {
        return ConditionalRuleSetFactory.createForContainer(parent, definition, json, true, false);
      };
      if (definition.defaultConditionalValue instanceof Function) {
        container.except.push(definition.fieldName);
        container.createEmbeddedObject[definition.fieldName] = definition.defaultConditionalValue;
      }
    }
  }

}